export default __webpack_public_path__ + "static/media/PricingCard1.995ff666.png";